import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Relative } from '../../../../api/app-types/relative.app';

@Component({
	selector: 'lvr-other-relatives-item',
	templateUrl: './other-relatives-item.html',
	styleUrl: './other-relatives-item.scss',
	imports: [TranslocoPipe],
})
export class OtherRelativesItem {
	public readonly relative = input.required<Relative>();
	public readonly hasBottomBorder = input<boolean>(true);

	public name(): string {
		const rel = this.relative();
		return `${rel.lastName}, ${rel.firstName}`;
	}
}
